/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterPromotionCodeAddPost } from '../fn/promotion-code/api-master-promotion-code-add-post';
import { ApiMasterPromotionCodeAddPost$Params } from '../fn/promotion-code/api-master-promotion-code-add-post';
import { apiMasterPromotionCodeDeleteGet } from '../fn/promotion-code/api-master-promotion-code-delete-get';
import { ApiMasterPromotionCodeDeleteGet$Params } from '../fn/promotion-code/api-master-promotion-code-delete-get';
import { apiMasterPromotionCodeEditPost } from '../fn/promotion-code/api-master-promotion-code-edit-post';
import { ApiMasterPromotionCodeEditPost$Params } from '../fn/promotion-code/api-master-promotion-code-edit-post';
import { apiMasterPromotionCodeGetActiveGet } from '../fn/promotion-code/api-master-promotion-code-get-active-get';
import { ApiMasterPromotionCodeGetActiveGet$Params } from '../fn/promotion-code/api-master-promotion-code-get-active-get';
import { apiMasterPromotionCodeGetAllGet } from '../fn/promotion-code/api-master-promotion-code-get-all-get';
import { ApiMasterPromotionCodeGetAllGet$Params } from '../fn/promotion-code/api-master-promotion-code-get-all-get';
import { apiMasterPromotionCodeGetByCriteriaPost } from '../fn/promotion-code/api-master-promotion-code-get-by-criteria-post';
import { ApiMasterPromotionCodeGetByCriteriaPost$Params } from '../fn/promotion-code/api-master-promotion-code-get-by-criteria-post';
import { apiMasterPromotionCodeGetByIdGet } from '../fn/promotion-code/api-master-promotion-code-get-by-id-get';
import { ApiMasterPromotionCodeGetByIdGet$Params } from '../fn/promotion-code/api-master-promotion-code-get-by-id-get';
import { apiMasterPromotionCodeValidateGet } from '../fn/promotion-code/api-master-promotion-code-validate-get';
import { ApiMasterPromotionCodeValidateGet$Params } from '../fn/promotion-code/api-master-promotion-code-validate-get';
import { DecimalApiRespModel } from '../models/decimal-api-resp-model';
import { PromotionCode } from '../models/promotion-code';
import { PromotionCodeApiRespModel } from '../models/promotion-code-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class PromotionCodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterPromotionCodeAddPost()` */
  static readonly ApiMasterPromotionCodeAddPostPath = '/api/Master/PromotionCode/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeAddPost$Response(params?: ApiMasterPromotionCodeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCodeApiRespModel>> {
    return apiMasterPromotionCodeAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeAddPost(params?: ApiMasterPromotionCodeAddPost$Params, context?: HttpContext): Observable<PromotionCodeApiRespModel> {
    return this.apiMasterPromotionCodeAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PromotionCodeApiRespModel>): PromotionCodeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeEditPost()` */
  static readonly ApiMasterPromotionCodeEditPostPath = '/api/Master/PromotionCode/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeEditPost$Response(params?: ApiMasterPromotionCodeEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCodeApiRespModel>> {
    return apiMasterPromotionCodeEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeEditPost(params?: ApiMasterPromotionCodeEditPost$Params, context?: HttpContext): Observable<PromotionCodeApiRespModel> {
    return this.apiMasterPromotionCodeEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PromotionCodeApiRespModel>): PromotionCodeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeDeleteGet()` */
  static readonly ApiMasterPromotionCodeDeleteGetPath = '/api/Master/PromotionCode/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeDeleteGet$Response(params?: ApiMasterPromotionCodeDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterPromotionCodeDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeDeleteGet(params?: ApiMasterPromotionCodeDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterPromotionCodeDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeGetAllGet()` */
  static readonly ApiMasterPromotionCodeGetAllGetPath = '/api/Master/PromotionCode/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetAllGet$Response(params?: ApiMasterPromotionCodeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromotionCode>>> {
    return apiMasterPromotionCodeGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetAllGet(params?: ApiMasterPromotionCodeGetAllGet$Params, context?: HttpContext): Observable<Array<PromotionCode>> {
    return this.apiMasterPromotionCodeGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromotionCode>>): Array<PromotionCode> => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeGetActiveGet()` */
  static readonly ApiMasterPromotionCodeGetActiveGetPath = '/api/Master/PromotionCode/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetActiveGet$Response(params?: ApiMasterPromotionCodeGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromotionCode>>> {
    return apiMasterPromotionCodeGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetActiveGet(params?: ApiMasterPromotionCodeGetActiveGet$Params, context?: HttpContext): Observable<Array<PromotionCode>> {
    return this.apiMasterPromotionCodeGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromotionCode>>): Array<PromotionCode> => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeGetByCriteriaPost()` */
  static readonly ApiMasterPromotionCodeGetByCriteriaPostPath = '/api/Master/PromotionCode/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeGetByCriteriaPost$Response(params?: ApiMasterPromotionCodeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromotionCode>>> {
    return apiMasterPromotionCodeGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterPromotionCodeGetByCriteriaPost(params?: ApiMasterPromotionCodeGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<PromotionCode>> {
    return this.apiMasterPromotionCodeGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PromotionCode>>): Array<PromotionCode> => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeGetByIdGet()` */
  static readonly ApiMasterPromotionCodeGetByIdGetPath = '/api/Master/PromotionCode/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetByIdGet$Response(params?: ApiMasterPromotionCodeGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCode>> {
    return apiMasterPromotionCodeGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeGetByIdGet(params?: ApiMasterPromotionCodeGetByIdGet$Params, context?: HttpContext): Observable<PromotionCode> {
    return this.apiMasterPromotionCodeGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PromotionCode>): PromotionCode => r.body)
    );
  }

  /** Path part for operation `apiMasterPromotionCodeValidateGet()` */
  static readonly ApiMasterPromotionCodeValidateGetPath = '/api/Master/PromotionCode/Validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterPromotionCodeValidateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeValidateGet$Response(params?: ApiMasterPromotionCodeValidateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DecimalApiRespModel>> {
    return apiMasterPromotionCodeValidateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterPromotionCodeValidateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterPromotionCodeValidateGet(params?: ApiMasterPromotionCodeValidateGet$Params, context?: HttpContext): Observable<DecimalApiRespModel> {
    return this.apiMasterPromotionCodeValidateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DecimalApiRespModel>): DecimalApiRespModel => r.body)
    );
  }

}
